import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

export interface LinhaLogAtividade {
  id: string;
  dataHora: string;
  usuarioEmail: string | null;
  acao: string;
  acaoRotulo: string;
  grupo: string;
  registroId: string | null;
  ip: string | null;
  sucesso: boolean;
}

export interface FiltrosLog {
  acao?: string;
  dataInicial?: string;
  dataFinal?: string;
  page?: number;
  size?: number;
}

const montarParams = (filtros: FiltrosLog) => {
  const p = new URLSearchParams();
  if (filtros.acao) p.append("acao", filtros.acao);
  if (filtros.dataInicial) p.append("dataInicial", filtros.dataInicial);
  if (filtros.dataFinal) p.append("dataFinal", filtros.dataFinal);
  p.append("page", String(filtros.page ?? 0));
  p.append("size", String(filtros.size ?? 25));
  return p.toString();
};

const listar = async (filtros: FiltrosLog) => {
  const r = await handleService({
    method: MethodsEnum.GET,
    endpoint: `/relatorios/log-atividades?${montarParams(filtros)}`,
  });
  return r?.data ?? null;
};

/**
 * Busca tudo que bate com o filtro, para o PDF. A tela mostra 25 por vez; um
 * PDF com so a pagina visivel nao serve para nada.
 *
 * Teto de seguranca: sem ele, um filtro aberto num ano de log puxaria dezenas
 * de milhares de linhas para dentro do navegador de uma vez.
 */
const listarTudoParaExportar = async (filtros: FiltrosLog, teto = 2000) => {
  const linhas: LinhaLogAtividade[] = [];
  let page = 0;
  while (linhas.length < teto) {
    const p = await listar({ ...filtros, page, size: 200 });
    if (!p?.content?.length) break;
    linhas.push(...p.content);
    if (p.last) break;
    page += 1;
  }
  return { linhas: linhas.slice(0, teto), truncado: linhas.length >= teto };
};

const relatorioService = { listar, listarTudoParaExportar };
export default relatorioService;
